import { Checkbox as MuiCheckbox } from '@mui/material';
import { FormControlLabel } from './FormControlLabel';
import type { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';

export type CheckboxProps = MuiCheckboxProps & { label?: string };

export const Checkbox = ({ label, ...rest }: CheckboxProps): JSX.Element =>
  label ? (
    <FormControlLabel control={<MuiCheckbox {...rest} />} label={label} />
  ) : (
    <MuiCheckbox {...rest} />
  );
